(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2790],{

/***/ 19236:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ Title; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Title/Title.styles.js


var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
function getFontSize(size, element, theme) {
  if (typeof size !== "undefined") {
    return size in theme.headings.sizes ? theme.headings.sizes[size].fontSize : size;
  }
  return theme.headings.sizes[element].fontSize;
}
function getLineHeight(size, element, theme) {
  if (typeof size !== "undefined" && size in theme.headings.sizes) {
    return theme.headings.sizes[size].lineHeight;
  }
  return theme.headings.sizes[element].lineHeight;
}
var useStyles = (0,create_styles/* createStyles */.k)((theme, { element, weight, size, inline }) => ({
  root: __spreadProps(__spreadValues({}, theme.fn.fontStyles()), {
    fontFamily: theme.headings.fontFamily,
    fontWeight: weight || theme.headings.sizes[element].fontWeight || theme.headings.fontWeight,
    fontSize: getFontSize(size, element, theme),
    lineHeight: inline ? 1 : getLineHeight(size, element, theme),
    margin: 0
  })
}));

/* harmony default export */ var Title_styles = (useStyles);
//# sourceMappingURL=Title.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(95117);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Title/Title.js





var Title_defProp = Object.defineProperty;
var Title_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Title_hasOwnProp = Object.prototype.hasOwnProperty;
var Title_propIsEnum = Object.prototype.propertyIsEnumerable;
var Title_defNormalProp = (obj, key, value) => key in obj ? Title_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Title_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Title_hasOwnProp.call(b, prop))
      Title_defNormalProp(a, prop, b[prop]);
  if (Title_getOwnPropSymbols)
    for (var prop of Title_getOwnPropSymbols(b)) {
      if (Title_propIsEnum.call(b, prop))
        Title_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Title_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Title_getOwnPropSymbols)
    for (var prop of Title_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Title_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  order: 1
};
const Title = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Title", defaultProps, props), { className, order, children, unstyled, size, weight, inline } = _a, others = __objRest(_a, ["className", "order", "children", "unstyled", "size", "weight", "inline"]);
  const { classes, cx } = Title_styles({ element: `h${order}`, weight, size, inline }, { name: "Title", unstyled });
  if (![1, 2, 3, 4, 5, 6].includes(order)) {
    return null;
  }
  return /* @__PURE__ */ react.createElement(Text/* Text */.x, Title_spreadValues({
    component: `h${order}`,
    ref,
    className: cx(classes.root, className)
  }, others), children);
});
Title.displayName = "@mantine/core/Title";


//# sourceMappingURL=Title.js.map


/***/ }),

/***/ 20376:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tuyen-dung",
      function () {
        return __webpack_require__(27101);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 51223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ fetchPageInfo; },
/* harmony export */   "u": function() { return /* binding */ useFetchPageInfo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67848);
/* harmony import */ var _fetch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36203);




var DEFAULT_STALE_TIME = 600000; // 10min
var fetchPageInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(slug) {
        var locale, data, _args = arguments;
        return _root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    locale = _args.length > 1 && _args[1] !== void 0 ? _args[1] : "vi";
                    if (slug) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return", undefined);
                case 3:
                    _ctx.next = 5;
                    return (0,_fetch__WEBPACK_IMPORTED_MODULE_1__/* .asyncGetItem */ .p9)({
                        collection_name: "news",
                        options: {
                            condition: {
                                ngon_ngu: locale,
                                slug: slug,
                                shared: true,
                                loai_tin_tuc: "Trang tuyển dụng"
                            }
                        }
                    });
                case 5:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", data);
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchPageInfo(slug) {
        return _ref.apply(this, arguments);
    };
}();
var useFetchPageInfo = function(slug, locale) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a)([
        "pageInfo",
        slug,
        locale
    ], function() {
        return fetchPageInfo(slug, locale);
    }, {
        staleTime: DEFAULT_STALE_TIME
    });
};


/***/ }),

/***/ 51623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_appendImageUrlFromAPI__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22312);
/* harmony import */ var _utils_lodash__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59926);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2962);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);







function DefaultSEO(param) {
    var seo = param.seo;
    // console.log(445555, seo)
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().locale;
    if (!seo || (0,_utils_lodash__WEBPACK_IMPORTED_MODULE_5__/* .isEmpty */ .xb)(seo)) return null;
    var images = [];
    if (seo.picture1) {
        images.push({
            url: (0,_utils_appendImageUrlFromAPI__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                src: seo.picture1,
                size: "xl"
            }),
            width: 1200,
            height: 630,
            alt: "Vi\xeạt Thi\xean",
            type: "image/*"
        });
    } else if (seo.picture2) {
        images.push({
            url: (0,_utils_appendImageUrlFromAPI__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                src: seo.picture2,
                size: "xl"
            }),
            width: 1200,
            height: 1200,
            alt: "Vi\xeạt Thi\xean",
            type: "image/*"
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_2__/* .NextSeo */ .PB, {
        title: seo === null || seo === void 0 ? void 0 : seo.title,
        description: seo === null || seo === void 0 ? void 0 : seo.description,
        openGraph: {
            url: "https://vietthien.com",
            title: seo.title,
            description: seo.description,
            images: images,
            locale: locale,
            type: seo.type || "website",
            siteName: "Việt Thi\xean",
            article: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, (seo === null || seo === void 0 ? void 0 : seo.article) || {})
        }
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (DefaultSEO);


/***/ }),

/***/ 41291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PageContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72445);





function PageContainer(_param) {
    var children = _param.children, style = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        size: "lg"
    }, style), {
        children: children
    }));
};


/***/ }),

/***/ 27101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ LienHe; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./apis/queryFunctions/pageInfo.js
var queryFunctions_pageInfo = __webpack_require__(51223);
// EXTERNAL MODULE: ./common/components/DefaultSEO.js
var DefaultSEO = __webpack_require__(51623);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./common/components/PageContainer.js
var PageContainer = __webpack_require__(41291);
// EXTERNAL MODULE: ./setup/locale-provider/index.js
var locale_provider = __webpack_require__(59963);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(62679);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Title/Title.js + 1 modules
var Title_Title = __webpack_require__(19236);
// EXTERNAL MODULE: ./node_modules/next/dist/client/router.js
var client_router = __webpack_require__(90387);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text_Text = __webpack_require__(95117);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 1 modules
var Box_Box = __webpack_require__(64523);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(67841);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Table/Table.styles.js


var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var useStyles = (0,create_styles/* createStyles */.k)((theme, {
  captionSide,
  horizontalSpacing,
  verticalSpacing,
  fontSize,
  withBorder,
  withColumnBorders
}) => {
  const border = `1px solid ${theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3]}`;
  return {
    root: __spreadProps(__spreadValues({}, theme.fn.fontStyles()), {
      width: "100%",
      borderCollapse: "collapse",
      captionSide,
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
      lineHeight: theme.lineHeight,
      border: withBorder ? border : "",
      "& caption": {
        marginTop: captionSide === "top" ? 0 : theme.spacing.xs,
        marginBottom: captionSide === "bottom" ? 0 : theme.spacing.xs,
        fontSize: theme.fontSizes.sm,
        color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[6]
      },
      "& thead tr th, & tfoot tr th, & tbody tr th": {
        textAlign: "left",
        fontWeight: "bold",
        color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.gray[7],
        fontSize: theme.fn.size({ size: fontSize, sizes: theme.fontSizes }),
        padding: `${theme.fn.size({
          size: verticalSpacing,
          sizes: theme.spacing
        })}px ${theme.fn.size({ size: horizontalSpacing, sizes: theme.spacing })}px`
      },
      "& thead tr th": {
        borderBottom: border
      },
      "& tfoot tr th, & tbody tr th": {
        borderTop: border
      },
      "& tbody tr td": {
        padding: `${theme.fn.size({
          size: verticalSpacing,
          sizes: theme.spacing
        })}px ${theme.fn.size({ size: horizontalSpacing, sizes: theme.spacing })}px`,
        borderTop: border,
        fontSize: theme.fn.size({ size: fontSize, sizes: theme.fontSizes })
      },
      "& tbody tr:first-of-type td, & tbody tr:first-of-type th": {
        borderTop: "none"
      },
      "& thead th, & tbody td": {
        borderRight: withColumnBorders ? border : "none",
        "&:last-of-type": {
          borderRight: "none",
          borderLeft: withColumnBorders ? border : "none"
        }
      },
      "& tbody tr th": {
        borderRight: withColumnBorders ? border : "none"
      },
      "&[data-striped] tbody tr:nth-of-type(odd)": {
        backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[0]
      },
      "&[data-hover] tbody tr": theme.fn.hover({
        backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[1]
      })
    })
  };
});

/* harmony default export */ var Table_styles = (useStyles);
//# sourceMappingURL=Table.styles.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Table/Table.js





var Table_defProp = Object.defineProperty;
var Table_defProps = Object.defineProperties;
var Table_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var Table_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Table_hasOwnProp = Object.prototype.hasOwnProperty;
var Table_propIsEnum = Object.prototype.propertyIsEnumerable;
var Table_defNormalProp = (obj, key, value) => key in obj ? Table_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Table_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Table_hasOwnProp.call(b, prop))
      Table_defNormalProp(a, prop, b[prop]);
  if (Table_getOwnPropSymbols)
    for (var prop of Table_getOwnPropSymbols(b)) {
      if (Table_propIsEnum.call(b, prop))
        Table_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var Table_spreadProps = (a, b) => Table_defProps(a, Table_getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Table_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Table_getOwnPropSymbols)
    for (var prop of Table_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Table_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  striped: false,
  highlightOnHover: false,
  captionSide: "top",
  horizontalSpacing: "xs",
  fontSize: "sm",
  verticalSpacing: 7,
  withBorder: false,
  withColumnBorders: false
};
const Table = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Table", defaultProps, props), {
    className,
    children,
    striped,
    highlightOnHover,
    captionSide,
    horizontalSpacing,
    verticalSpacing,
    fontSize,
    unstyled,
    withBorder,
    withColumnBorders
  } = _a, others = __objRest(_a, [
    "className",
    "children",
    "striped",
    "highlightOnHover",
    "captionSide",
    "horizontalSpacing",
    "verticalSpacing",
    "fontSize",
    "unstyled",
    "withBorder",
    "withColumnBorders"
  ]);
  const { classes, cx } = Table_styles({ captionSide, verticalSpacing, horizontalSpacing, fontSize, withBorder, withColumnBorders }, { unstyled, name: "Table" });
  return /* @__PURE__ */ react.createElement(Box_Box/* Box */.x, Table_spreadProps(Table_spreadValues({}, others), {
    component: "table",
    ref,
    className: cx(classes.root, className),
    "data-striped": striped || void 0,
    "data-hover": highlightOnHover || void 0
  }), children);
});
Table.displayName = "@mantine/core/Table";


//# sourceMappingURL=Table.js.map

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./pages/tuyen-dung/components/JobTable.js






// import { useState } from "react";
function JobTable() {
    var getLabel = (0,locale_provider/* useLocalContext */.u)().getLabel;
    // const [value, setValue] = useState({
    //   position: "",
    //   career: "",
    //   location: "",
    // });
    // const [subValue, setSubValue] = useState({
    //   position: "",
    //   career: "",
    //   location: "",
    // });
    var locale = (0,router.useRouter)().locale;
    var push = (0,router.useRouter)().push;
    var ref = (0,queryFunctions_pageInfo/* useFetchPageInfo */.u)("trang-tuyen-dung", locale), pageInfo = ref.data;
    var ref1 = pageInfo || {}, data = ref1.add_on_data;
    // console.log('data', pageInfo)
    // console.log('content_2', pageInfo?.content_2)
    var label = {
        vi: {
            thead: [
                "STT",
                "Vị tr\xed tuyển dụng",
                "Ng\xe0nh nghề",
                "Hạn nộp hồ sơ",
                ""
            ],
            notification: "Hiện tại chưa c\xf3 th\xf4ng tin tuyển dụng n\xe0o",
            buttonSubmit: "Ứng tuyển"
        },
        en: {
            thead: [
                "NO.",
                "Vacancies",
                "Career",
                "Deadlines",
                ""
            ],
            notification: "There are no job postings yet",
            buttonSubmit: "Apply"
        }
    };
    var rows = data && (data === null || data === void 0 ? void 0 : data.filter(function(el) {
        return el.shared;
    }).map(function(element, index) {
        var ref;
        // <Link key={index} href={`/tuyen-dung/${element.content_2}`}>
        //   {/* <a> */}
        //   {/* </a> */}
        // </Link>
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("tr", {
            style: {
                fontWeight: 500
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    style: {
                        borderBottom: "none",
                        width: "5%"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* Text */.x, {
                        size: "sm",
                        align: "center",
                        children: index + 1
                    })
                }, "stt".concat(index)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    style: {
                        borderBottom: "none",
                        width: "30%"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/tuyen-dung/".concat(element.content_2),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* Text */.x, {
                                size: "sm",
                                children: getLabel(element.title)
                            })
                        })
                    }, index)
                }, "position".concat(index)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    style: {
                        borderBottom: "none",
                        width: "30%"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/tuyen-dung/".concat(element.content_2),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* Text */.x, {
                                size: "sm",
                                align: "center",
                                children: getLabel(element.content_3)
                            })
                        })
                    }, index)
                }, "career".concat(index)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    style: {
                        borderBottom: "none",
                        width: "20%"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* Text */.x, {
                        size: "sm",
                        align: "right",
                        weight: 400,
                        children: getLabel(element.summary)
                    })
                }, "location".concat(index)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    style: {
                        borderBottom: "none",
                        width: "15%"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* Box */.x, {
                        sx: {
                            display: "flex",
                            justifyContent: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            size: "sm",
                            sx: {
                                fontWeight: 500
                            },
                            onClick: function() {
                                return push("/tuyen-dung/".concat(element.content_2));
                            },
                            children: (ref = label[locale]) === null || ref === void 0 ? void 0 : ref.buttonSubmit
                        })
                    })
                }, "button".concat(index))
            ]
        }, index);
    }));
    // const onSubmit = (value) => {
    //   setValue(value);
    // };
    // const handleChangeLocation = (a) => {
    //   setSubValue({ ...subValue, location: a });
    // };
    // const handleChangeCareer = (a) => {
    //   setSubValue({ ...subValue, career: a });
    // };
    // function validateJob(job) {
    //   if (value.career != "" || value.location != "" || value.position != "") {
    //     // console.log();
    //     if (
    //       value.position != "" &&
    //       !removeVietnameseTones(job.position)
    //         .toUpperCase()
    //         .includes(removeVietnameseTones(value.position).toUpperCase())
    //     )
    //       return false;
    //     if (value.career != "" && job.career != value.career) return false;
    //     if (value.location != "" && job.location != value.location) return false;
    //   }
    //   return true;
    // }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table, {
                striped: true,
                highlightOnHover: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    style: {
                                        background: "#fff"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* Text */.x, {
                                        size: "md",
                                        weight: 700,
                                        children: label[locale].thead[0]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    style: {
                                        background: "#fff"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* Text */.x, {
                                        size: "md",
                                        weight: 700,
                                        children: getLabel(label[locale].thead[1])
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    style: {
                                        background: "#fff"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* Text */.x, {
                                        size: "md",
                                        align: "center",
                                        children: getLabel(label[locale].thead[2])
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    style: {
                                        background: "#fff"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* Text */.x, {
                                        size: "md",
                                        align: "right",
                                        children: getLabel(label[locale].thead[3])
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    style: {
                                        background: "#fff"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* Text */.x, {
                                        size: "md",
                                        align: "right"
                                    })
                                })
                            ]
                        })
                    }),
                    data && data.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                        children: rows
                    })
                ]
            }),
            data && data.length == 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* Text */.x, {
                size: "sm",
                align: "center",
                sx: {
                    paddingTop: 20
                },
                children: label[locale].notification
            })
        ]
    });
};

// EXTERNAL MODULE: ./utils/sanitizeDOMData.js
var utils_sanitizeDOMData = __webpack_require__(60959);
;// CONCATENATED MODULE: ./pages/tuyen-dung/components/Method.js







function Method() {
    var ref;
    var getLabel = useLocalContext().getLabel;
    var locale = useRouter().locale;
    var data = useFetchPageInfo("hinh-thuc-nop-ho-so", locale).data;
    var label = {
        vi: {
            title: "H\xecnh thức nộp hồ sơ"
        },
        en: {
            title: "How to apply with us?"
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        style: {
            padding: "0 16px"
        },
        children: [
            /*#__PURE__*/ _jsx(Box, {
                sx: {
                    // minWidth: 400,
                    maxWidth: 500,
                    minHeight: 50,
                    // height: 50,
                    background: "#fff",
                    textAlign: "center",
                    justifyContent: "center",
                    padding: "10px 5px",
                    marginBottom: 10,
                    marginTop: 10
                },
                children: /*#__PURE__*/ _jsx(Title, {
                    order: 5,
                    sx: {
                        height: "100%"
                    },
                    children: getLabel((ref = label[locale]) === null || ref === void 0 ? void 0 : ref.title)
                })
            }),
            /*#__PURE__*/ _jsx(Box, {
                sx: {
                    // minWidth: 400,
                    maxWidth: 500,
                    //   maxHeight: 500,
                    height: 520,
                    background: "#f0f0f0",
                    border: "1px solid #bababa",
                    padding: "0px 0px 20px 20px",
                    overflow: "hidden",
                    // overflowX: "hidden",
                    overflowY: "auto"
                },
                children: data && /*#__PURE__*/ _jsx("div", {
                    className: "webview",
                    children: /*#__PURE__*/ _jsx(Text, {
                        children: sanitizeDOMData(data === null || data === void 0 ? void 0 : data.content)
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/tuyen-dung/components/Career.js







function Career() {
    var getLabel = (0,locale_provider/* useLocalContext */.u)().getLabel;
    var locale = (0,client_router.useRouter)().locale;
    var titlePage = {
        vi: getLabel("Th\xf4ng tin tuyển dụng"),
        en: getLabel("Employment information")
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageContainer/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid */.r, {
            gutter: 0,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                sm: 12,
                lg: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageContainer/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title_Title/* Title */.D, {
                            order: 4,
                            children: titlePage[locale]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(JobTable, {})
                    ]
                })
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./pages/tuyen-dung/components/HRTerm.js




var HRTerm_useStyles = (0,create_styles/* createStyles */.k)(function(theme) {
    var _obj, _obj1, _obj2;
    return {
        left: (_obj = {
            padding: "150px",
            background: "#FFF"
        }, // overflow: "hidden",
        // overflowX: "hidden",
        // overflowY: " scroll",
        // Dynamic media queries, define breakpoints in theme, use anywhere
        (0,_define_property/* default */.Z)(_obj, "@media (max-width: 1700px)", {
            padding: "100px"
        }), (0,_define_property/* default */.Z)(_obj, "@media (max-width: 1600px)", {
            padding: "80px"
        }), (0,_define_property/* default */.Z)(_obj, "@media (max-width: ".concat(theme.breakpoints.md, "px)"), {
            padding: "50px 50px 50px 50px"
        }), (0,_define_property/* default */.Z)(_obj, "@media (max-width: ".concat(theme.breakpoints.sm, "px)"), {
            padding: "20px 20px 20px 20px"
        }), _obj),
        right: (_obj1 = {
            padding: "150px",
            background: "rgba(14, 159, 153)",
            color: "#FFF"
        }, // Dynamic media queries, define breakpoints in theme, use anywhere
        (0,_define_property/* default */.Z)(_obj1, "@media (max-width: 1700px)", {
            padding: "100px"
        }), (0,_define_property/* default */.Z)(_obj1, "@media (max-width: 1600px)", {
            padding: "80px"
        }), (0,_define_property/* default */.Z)(_obj1, "@media (max-width: ".concat(theme.breakpoints.md, "px)"), {
            padding: "50px 50px 50px 50px"
        }), (0,_define_property/* default */.Z)(_obj1, "@media (max-width: ".concat(theme.breakpoints.sm, "px)"), {
            padding: "20px 20px 20px 20px"
        }), _obj1),
        text: (_obj2 = {
            minHeight: 300,
            marginTop: 26,
            // overflow: "none",
            overflow: "hidden",
            overflowX: "hidden",
            overflowY: "auto"
        }, (0,_define_property/* default */.Z)(_obj2, "::-webkit-scrollbar", {
            width: 5
        }), (0,_define_property/* default */.Z)(_obj2, "::-webkit-scrollbar-thumb", {
            background: "gray",
            borderRadius: 10
        }), _obj2),
        line: {
            height: 2,
            background: "rgba(14, 159, 153,.7)",
            width: 106,
            marginTop: 10
        },
        lineRight: {
            height: 2,
            background: "#FFF",
            width: 106,
            marginTop: 10
        }
    };
});
function HRTerm(param) {
    var _src = param.src, src = _src === void 0 ? "https://zengroup.com.vn/wp-content/uploads/2022/04/du-an-nha-mat-tien-Q12-1024x768.jpg" : _src, _title = param.title, title = _title === void 0 ? "Why to choose" : _title, label = param.label, index = param.index;
    var classes = HRTerm_useStyles().classes;
    var link = src || null;
    if (link != null) {
        if (link && link.indexOf("http") < 0) {
            link = "".concat("https://api.flexzen.app").concat(link, "?access_token=").concat("flex.public.token", "&trustkey=").concat("APP.FKJSHHHH908KJF");
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid */.r, {
        cols: "2",
        gutter: 0,
        sx: {
            backgroundImage: " url(".concat(link, ")"),
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover"
        },
        children: index % 2 == 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                    xs: 2,
                    sm: 3,
                    md: 4,
                    lg: 6
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                    xs: 10,
                    sm: 9,
                    md: 8,
                    lg: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* Box */.x, {
                        className: classes.right,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title_Title/* Title */.D, {
                                order: 4,
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classes.lineRight
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classes.text,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* Text */.x, {
                                    size: "lg",
                                    sx: {
                                        paddingTop: 10
                                    },
                                    align: "justify",
                                    children: (0,utils_sanitizeDOMData/* default */.Z)(label)
                                })
                            })
                        ]
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                    xs: 10,
                    sm: 9,
                    md: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* Box */.x, {
                        className: classes.left,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title_Title/* Title */.D, {
                                order: 4,
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classes.line
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classes.text,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* Text */.x, {
                                    size: "lg",
                                    style: {
                                        paddingTop: 10
                                    },
                                    align: "justify",
                                    children: (0,utils_sanitizeDOMData/* default */.Z)(label)
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                    xs: 2,
                    sm: 3,
                    md: 6
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./pages/tuyen-dung/index.page.js







var TabsLabel = {
    vi: [
        {
            value: "1",
            label: "Cơ hội nghề nghiệp"
        },
        {
            value: "2",
            label: "Ch\xednh s\xe1ch nh\xe2n sự"
        }, 
    ],
    en: [
        {
            value: "1",
            label: "Career opportunities"
        },
        {
            value: "2",
            label: "HR policies"
        }, 
    ]
};
var seo = {
    vi: {
        title: "Tuyển dụng"
    },
    en: {
        title: "Recruitment"
    }
};
function LienHe() {
    // const { getLabel } = useLocalContext();
    var locale = (0,router.useRouter)().locale;
    var ref = (0,react.useState)("1"), activeTab = ref[0], setActiveTab = ref[1];
    var data = (0,queryFunctions_pageInfo/* useFetchPageInfo */.u)("chinh-sach-nhan-su", locale).data;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            paddingBottom: 55
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultSEO/* default */.Z, {
                seo: seo[locale]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        paddingTop: 60
                    },
                    children: activeTab == "2" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: data && data.add_on_data.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(HRTerm, {
                                title: item.title,
                                label: item.content,
                                index: index,
                                src: item.picture
                            }, "content".concat(index));
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Career, {})
                })
            })
        ]
    });
};


/***/ }),

/***/ 60959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ sanitizeDOMData; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25935);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2__);





var parseOptions = {
    replace: function(param) {
        var attribs = param.attribs, children = param.children;
        if (!attribs) {
            return;
        }
        if (attribs.dir === "ltr") {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_1__/* .domToReact */ .du)(children)
            });
        }
    }
};
function sanitizeDOMData(htmlString) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        replace: parseOptions.replace
    };
    var cleanString = isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2___default().sanitize(htmlString, {
        USE_PROFILES: {
            html: true
        }
    });
    var html = (0,html_react_parser__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(cleanString, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, options), {
        trim: true
    }));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "webview",
        children: html
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3987,9774,2888,179], function() { return __webpack_exec__(20376); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);